import { chain } from 'lodash'

const queryKeyToMutationKeyMap = {
    startDate: 'setStartDate',
    endDate: 'setEndDate'
}
const queryValueToMutationValueMap = {
    startDate: (dateString) => createDate(dateString),
    endDate: (dateString) => createDate(dateString)
}

function createDate (dateString) {
    let match = dateString.match(/^(\d{2})\.(\d{2})\.(\d{4})$/) || []
    if (match === null) return

    match = [match[3], match[2], match[1]]
    match = match.map((part) => parseInt(part, 10))

    return new Date(match[0], match[1] - 1, match[2])
}

export default {
    created () {
        const queries = chain(this.$route.query)
            .pick(Object.keys(queryKeyToMutationKeyMap))
            .mapValues((value, key) => queryValueToMutationValueMap[key] ? queryValueToMutationValueMap[key](value) : value)
            .mapKeys((value, key) => queryKeyToMutationKeyMap[key])
            .value()

        for (const [key, value] of Object.entries(queries)) {
            this.$store.commit(key, value)
        }
    }
}
